import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class UrlMapService {
  baseUrl = environment.base_url;

  constructor() { }

  /** return portalsite details url */
  portalsiteDetailUrl() {
    return this.baseUrl.concat('/v1/common/portalsite-details/agents/');
  }

  getPhotosUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/');
  }

  getOfficePhotosUrl() {
    return this.baseUrl.concat('/v1/office/');
  }

  /** return upload images for photos page url */
  uploadPhotosUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/upload-photos?');
  }

  uploadOfficePhotosUrl() {
    return this.baseUrl.concat('/v1/office/photos?');
  }

  saveImagesUrl() {
    return this.baseUrl.concat('/v1/office/photos');
  }

  changeSelectedUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/default-photo?');
  }

  deleteImageUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/');
  }

  /** get primary office details url */
  getPrimaryOfficeUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/');
  }

  /** get Designations for agent Url */
  getDesignations() {
    return this.baseUrl.concat('/v1/personal-info/agents/');
  }

  /** Save Designations for agent Url */
  saveDesignations() {
    return this.baseUrl.concat('/v1/personal-info/agents/designations');
  }

  /** get logos details url */
  getLogosUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/');
  }

  /** save logo url */
  saveDefaultLogoUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/default-logo?');
  }

  /** get bio details */
  getBiographyUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/');
  }

  /** save bio details */
  saveBiographyUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/biography');
  }

  /** get logos details url */
  shareQRCodeUrl() {
    return this.baseUrl.concat('/v1/common/share-qrcode');
  }

  /* get contact info url */
  getContactInfoUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/');
  }

  /* get user info url */
  getUserInfoUrl() {
    return this.baseUrl.concat('/v1/common/user-profile?winAuthUserName=');
  }

  /* get user info url */
  getUserDelegateByEmailUrl() {
    return this.baseUrl.concat('/v1/common/user-profile?userName=');
  }

  /* get user info url */
  getUserDelegateUrl() {
    return this.baseUrl.concat('/v1/common/user-profile?agentNumber=');
  }

  /* get states url */
  getStatesUrl() {
    return this.baseUrl.concat('/v1/common/lookup/types/State');
  }
  getAgentLicensedStateUrl()
  {
     return this.baseUrl.concat('/v1/common/lookup/types/AgentLicensedState/');
  }

  /* get county url */
  getCountyUrl() {
    return this.baseUrl.concat('/v1/common/lookup/types/County/');
  }

  /* get cities url */
  getCitiesUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/cities');
  }

  /* save county url */
  saveCountyUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/counties');
  }

  /* save county url */
  saveCityUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/cities');
  }

  /** get citilist url */
  getCityListUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/');
  }

  /** get countylist url */
  getCountyListUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/');
  }

  /** get mls companies url */
  getMLSCompanies() {
    return this.baseUrl.concat('/v1/personal-info/mls-companies');
  }

  /** get mls IDs url */
  getMLSIDs() {
    return this.baseUrl.concat('/v1/personal-info/agents/');
  }

  /** save mls IDs url */
  saveMLSIDs() {
    return this.baseUrl.concat('/v1/personal-info/agents/');
  }

  /** validate mls IDs url */
  validateMLSIDs() {
    return this.baseUrl.concat('/v1/personal-info/agents/');
  }
  /** get Specialties for agent Url */
  getSpecialitiesUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/');
  }

  /** save Specialties for agent Url */
  saveSpecialitiesUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/specialities/');
  }

  /** get zillow options for agent Url*/
  getZillowOptionUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/');
  }

  /** get Testimonial options for agent Url*/
  getTestimonialOptionUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/');
  }

  /** save zillow options for agent Url*/
  saveZillowOptionUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/');
  }

  /** save Testimonial options for agent Url*/
  saveTestimonialOptionUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/');
  }

  /** get Languages for agent Url */
  getLanguagesUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/');
  }

  /** get Languages for agent Url */
  saveLanguagesUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/languages/');
  }

  /** get primery core services Associations */
  getPrimeryCoreService() {
    return this.baseUrl.concat('/v1/personal-info/agents/')
  }

  /** get core service type Url */
  getCoreServiceType() {
    return this.baseUrl.concat('/v1/common/lookup/types/CoreServiceType')
  }

  /** get employee names Url */
  getCoreEmployeeName(){
    return this.baseUrl.concat('/v1/common/lookup/types/CoreServiceEmployeeAndOffice/')
  }

  /** get social Network links */
  getSocialNetworkLinksUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/');
  }

  /** Save social Network links */
  saveSocialNetworkLinksUrl() {
    return this.baseUrl.concat('/v1/personal-info/agents/social-networks');
  }

  /** get authentisign subscription url */
  getAuthentisignSubscriptionUrl() {
    return this.baseUrl.concat('/v1/subscription/agents/');
  }

  /** get authentisign subscription charge url  */
  getAuthentisignSubscriptionChargeUrl() {
    return this.baseUrl.concat('/v1/subscription/subscription-charge/')
  }
  
  /** get the saveAuthentisign subscription url */
  saveAuthentisignSubscriptionUrl() {
    return this.baseUrl.concat('/v1/subscription/agents/authenti-sign?')
  }

  /**get Delegate info */
  getDelegates() {
    return this.baseUrl.concat('/v1/delegate/agents/')
  }


  /** get team role info */
  getTeamRoles(){
    return this.baseUrl.concat('/v1/team/agent-team-info/')
  }

  /** save delegates */
  saveDelegates() {
    return this.baseUrl.concat('/v1/delegate')
  }

  /** regenerate password */
  regeneratePassword() {
    return this.baseUrl.concat('/v1/delegate/agents/regenerate-password')
  }

  /** get team member info */
  getTeamMemberInfo(){
    return this.baseUrl.concat('/v1/team/');
  }

  /** get team website info */
  getTeamWebsiteInfo(){
    return this.baseUrl.concat('/v1/website-account/team/');
  }

   /** get team member specialties */
   getTeamSpecialties(){
    return this.baseUrl.concat('/v1/team/');
  }
  
  /** subscripton detail */
  subscriptionDetail() {
    return this.baseUrl.concat('/v1/subscription/agents/');
  }

  /** agent info */
  getAgentInfo() {
    return this.baseUrl.concat('/v1/personal-info/agents/');
  }

  /** save docusign */
  docusign() {
    return this.baseUrl.concat('/v1/subscription/agents/docu-sign');
  }

  /** save toolkitCMA */
  saveToolkitCMASubscriptionURL(){
    return this.baseUrl.concat('/v1/subscription/agents/toolkit-cma?'); 
  }
 
  /** update auto renew in docusign */
  updateDocuSignAutoRenew() {
    return this.baseUrl.concat('/v1/subscription/agents/')
  }

  /** save docusign */
  youtubeListUrl() {
    return this.baseUrl.concat('/v1/subscription/agents/');
  } 

  /** get team Bio */  
  getTeamBio() {
    return this.baseUrl.concat('/v1/team/');
  }

  /** save team Bio */  
  saveTeamBio() {
    return this.baseUrl.concat('/v1/team/biography?');
  }

  /**get team agent photos*/
  getTeamPhotosUrl() {
    return this.baseUrl.concat('/v1/team/');
  }

  /**get default photo*/
  changeTeamSelectedUrl() {
    return this.baseUrl.concat('/v1/team/default-photo?');
  }

  /**baseurl for deleting team agent photos and getting team contact info url*/
  teamContactInfoBaseUrl(){
    return this.baseUrl.concat('/v1/team/');
  }

  /**upload team agent photos*/
  uploadTeamAgentPhotosUrl() {
    return this.baseUrl.concat('/v1/team/photos?');
  }

  /** get website Account info */
  getWebsiteAccountInfo(){
    return this.baseUrl.concat('/v1/website-account/agents/');
  }

  /** save team Socil Network */  
  saveTeamSocilNetwork() {
    return this.baseUrl.concat('/v1/team/social-networks');
  }

  /** get team website url */
  getTeamMemberWebsiteUrl(){
    return this.baseUrl.concat('/v1/website-account/team/');
  }

  /** save primary website for team member */  
  savePrimaryWebsiteUrl() {
    return this.baseUrl.concat('/v1/website-account/team/');
  }
  
  /** save non employee information */
  saveNonEmployeeUrl() {
    return this.baseUrl.concat('/v1/core-service/non-lnf-employee')
  }

  /** getEmployee Name based on core service Id */
  getEmployeelistBasedOnCoreService() {
    return this.baseUrl.concat('/v1/common/lookup/types/CoreServiceEmployee/')
  }

  /** get sales assignement Url */
  getSalesAssignmentsUrl() {
    return this.baseUrl.concat('/v1/core-service/')
  }

   /** get office showcase details */
   getOfficeShowcaseDetails() {
    return this.baseUrl.concat('/v1/office-showcase/')
  }

  /**creating office showcase */
  createOfficeTour(){
    return this.baseUrl.concat('/v1/office-showcase/')
    }
    
  /** save youtube list */
  saveYoutubeList() {
    return this.baseUrl.concat('/v1/subscription/agents/youtube');
  }

  /**update showcase */
  updateShowcaseFields(){
    return this.baseUrl.concat('/v1/office-showcase/');
  }

   /** get nonLnF details api method */
   getNonLnFDetail() {
     return this.baseUrl.concat('/v1/core-service/non-lnf-employee/');
   }

  /**delete showcase */
  deleteShowCaseId(){
    return this.baseUrl.concat('/v1/office-showcase/');
  }

  /** upload office promotion photo */
  uploadShowCasePhoto() {
    return this.baseUrl.concat('/v1/office-showcase/')
  }

  /** get office promotion details */
  getOfficePromotionDetails() {
    return this.baseUrl.concat('/v1/office-showcase/promotion-details/');
  }

  /** delete showcase */
  deleteShowCasePhoto() {
    return this.baseUrl.concat('/v1/office-showcase/');
  }

  /** to save promotion details */
  savePromotionDetails() {
    return this.baseUrl.concat('/v1/office-showcase/promotion-details/');
  }

  getOfficeLogos() {
    return this.baseUrl.concat('/v1/office/')
  }
  /** to get office phone numbers */
  getOfficePhoneNumbers() {
    return this.baseUrl.concat('/v1/office/');
  }

  /** get office website Account info */
  getOfficeWebsiteAccountInfo(){
    return this.baseUrl.concat('/v1/website-account/office');
  }
  /**to get the mls companies details for office */
  getMlsCompaniesDetails(){
    return this.baseUrl.concat('/v1/office/');
  }

  /**to add the mls companies details for office */
  saveOfficeMls(){
    return this.baseUrl.concat('/v1/office/mls-companies');
  }

  /*check if duplicate office mls exists */
  getDuplicateOfficeMls(){
    return this.baseUrl.concat('/v1/office/mls-companies/');
  }

  /**Save social Network affiliations for office */
  saveSocialNetworkAffilaitions() {
    return this.baseUrl.concat('/v1/office/social-networks');
  }

  /** leads crm url*/
  leadsCRMUrl() {
    return this.baseUrl.concat('/v1/leads/');
  }
  
  /**Save social Network affiliations for office */
  saveTeamName() {
    return this.baseUrl.concat('/v1/team/team-selection?teamId=');
  }

  /**Get delegate office/agants */
  getDelegateAgentsUrl(){
    return this.baseUrl.concat('/v1/personal-info/delegates/');
  }
}
